import { Loading } from 'components/loading';
import { UpdateEmployeePersonalDetailsInput } from 'features/employees/api/repositories/use-employee-personal-details-update.mutation';
import { WorkType } from 'features/shared/model';
import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

type Props = {
  isLoading: boolean;
  control: Control<UpdateEmployeePersonalDetailsInput>;
};

const TaxDetails: FC<Props> = ({ isLoading, control }) => {
  return (
    <div className="card mb-5 mb-xl-10">
      <div
        className="card-header border-0 cursor-pointer"
        role="button"
        data-bs-toggle="collapse"
        data-bs-target="#kt_tax_details_preferences"
        aria-expanded="true"
        aria-controls="kt_tax_details_preferences"
      >
        <div className="card-title m-0">
          <h3 className="fw-bolder m-0">Tax</h3>
        </div>
      </div>

      <div id="kt_form_tax_details_preferences" className="collapse show">
        <Controller
          name="input.requestBody.workType"
          control={control}
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <div className="card-body border-top px-9 py-9">
              <div className="fs-6 text-muted mb-10">
                If you do not have a P45 from your previous employer, Advance Motors will calculate your new tax code
                based on your answer to the questions below:
              </div>

              <div className="alert bg-light-secondary border border-secondary border-dashed h-90px py-7 mb-5">
                <label className="form-check form-check-custom form-check-solid form-check-secondary align-items-start">
                  <input
                    type="radio"
                    className="form-check-input me-3"
                    ref={ref}
                    onBlur={onBlur}
                    onChange={() => onChange(WorkType.FirstJob)}
                    checked={value == WorkType.FirstJob}
                  />

                  <span className="form-check-label d-flex flex-column align-items-start">
                    <span className="fs-6 text-muted">
                      A – This is my first job since last 6 April and{' '}
                      <span className="fw-bold text-black">I have not</span> been receiving taxable Jobseeker’s
                      Allowance, Employment and Support Allowance, taxable Incapacity Benefit, State or Occupational
                      pension.
                    </span>
                  </span>
                </label>
              </div>

              <div className="alert bg-light-secondary border border-secondary border-dashed h-90px py-7 mb-5">
                <label className="form-check form-check-custom form-check-solid form-check-secondary align-items-start">
                  <input
                    type="radio"
                    className="form-check-input me-3"
                    ref={ref}
                    onBlur={onBlur}
                    onChange={() => onChange(WorkType.TheOnlyJob)}
                    checked={value == WorkType.TheOnlyJob}
                  />

                  <span className="form-check-label d-flex flex-column align-items-start">
                    <span className="fs-6 text-muted">
                      B – This is now my only job, but since last 6 April{' '}
                      <span className="fw-bold text-black">I have</span> had another job, or received taxable
                      Jobseeker’s Allowance, Employment and Support Allowance or taxable Incapacity Benefit. I do not
                      receive a State or Occupational Pension.
                    </span>
                  </span>
                </label>
              </div>
              <div className="alert bg-light-secondary border border-secondary  border-dashed h-80px py-7 mb-5">
                <label className="form-check form-check-custom form-check-solid form-check-secondary align-items-start">
                  <input
                    type="radio"
                    className="form-check-input me-3"
                    ref={ref}
                    onBlur={onBlur}
                    onChange={() => onChange(WorkType.SecondJob)}
                    checked={value == WorkType.SecondJob}
                  />

                  <span className="form-check-label d-flex flex-column align-items-start">
                    <span className="fs-6 text-muted">
                      C – As well as my new job, I have another job or receive a State or Occupational Pension.
                    </span>
                  </span>
                </label>
              </div>
            </div>
          )}
        />
      </div>
      {isLoading && <Loading />}
    </div>
  );
};

export { TaxDetails };
